import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4974fd6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-card" }
const _hoisted_2 = { class: "detail-name" }
const _hoisted_3 = { class: "rel-header" }
const _hoisted_4 = {
  key: 0,
  class: "rel-caption"
}
const _hoisted_5 = { class: "rel-squares" }
const _hoisted_6 = {
  key: 0,
  class: "detail-summary"
}
const _hoisted_7 = {
  key: 0,
  class: "summary-item"
}
const _hoisted_8 = { class: "big-num" }
const _hoisted_9 = { class: "summary-sub" }
const _hoisted_10 = {
  key: 1,
  class: "summary-flag"
}
const _hoisted_11 = {
  key: 2,
  class: "summary-item"
}
const _hoisted_12 = { class: "big-num" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "summary-sub" }, "children", -1))
const _hoisted_14 = {
  key: 1,
  class: "detail-notes"
}
const _hoisted_15 = { class: "detail-events" }
const _hoisted_16 = { class: "ev-date" }
const _hoisted_17 = { class: "ev-year" }
const _hoisted_18 = {
  key: 0,
  class: "ev-daymonth"
}
const _hoisted_19 = { class: "ev-age" }
const _hoisted_20 = { class: "ev-body" }
const _hoisted_21 = { class: "ev-label" }
const _hoisted_22 = {
  key: 0,
  class: "ev-place"
}
const _hoisted_23 = { class: "ev-flag" }

import { computed } from 'vue'
import { MatchingCardPair } from './MatchingGameDefinition'
import { ageAt, dateDayMonthPart, dateYearPart, eventLabel, ordinalSuffix } from './MatchingGameHelpers'
import { getAncestorRelationText } from '@/rd/RelationPath'
import { Gender } from '@/rd/ResearchDataModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'MatchingDetailCard',
  props: {
    pair: {}
  },
  setup(__props: any) {

const props = __props;



const relSquaresRef = computed(() =>
  [...(props.pair.relationship || '')].map(step => (step === 'F' ? 'f' : 'm')))

// "Kent's grandfather" / "Marilyn's great-grandmother". The first square is the root couple member
// this line ascends from (F = Kent, M = Marilyn), so generations-up = length - 1; the final square
// gives the ancestor's gender. Names are hardcoded for now (matches the setup intro caption).
const relationTextRef = computed(() => {
  const rel = props.pair.relationship || ''
  const generations = rel.length - 1
  if (generations < 1) {
    return ''
  }
  const subject = rel[0] === 'F' ? 'Kent' : 'Marilyn'
  const gender = rel.at(-1) === 'F' ? Gender.Male : Gender.Female
  return `${subject}'s ${getAncestorRelationText(generations, gender)}`
})

const hasSummaryRef = computed(() =>
  !!(props.pair.childOrder && props.pair.siblingsCount) || !!props.pair.flag || !!props.pair.childCount)

// the card's primary text followed by any notes, joined with a space (either may be empty). When
// both are present and the primary text lacks terminal punctuation, add a period so the two read as
// separate sentences.
const notesTextRef = computed(() => {
  const text = props.pair.text?.trim() ?? ''
  const notes = props.pair.notes?.trim() ?? ''
  if (!text || !notes) {
    return text || notes
  }
  const punctuated = /[.!?]$/.test(text) ? text : `${text}.`
  return `${punctuated} ${notes}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.pair.name), 1),
    _createElementVNode("div", _hoisted_3, [
      (relationTextRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(relationTextRef.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relSquaresRef.value, (step, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: _normalizeClass(["rel-square", step])
          }, null, 2))
        }), 128))
      ])
    ]),
    (hasSummaryRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.pair.childOrder && _ctx.pair.siblingsCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.pair.childOrder), 1),
                  _createElementVNode("sup", null, _toDisplayString(_unref(ordinalSuffix)(_ctx.pair.childOrder)), 1)
                ]),
                _createElementVNode("div", _hoisted_9, "of " + _toDisplayString(_ctx.pair.siblingsCount) + " children", 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.pair.flag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: _normalizeClass(["fi", `fi-${_ctx.pair.flag}`])
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.pair.childCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.pair.childCount), 1),
                _hoisted_13
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (notesTextRef.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(notesTextRef.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pair.details, (detail, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass(["event-row", { highlight: detail.highlight }])
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(dateYearPart)(detail.date)), 1),
            (_unref(dateDayMonthPart)(detail.date))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(dateDayMonthPart)(detail.date)), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(ageAt)(_ctx.pair, detail.date)), 1),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(eventLabel)(detail)), 1),
            (detail.place)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(detail.place), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            (detail.flag)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["fi", `fi-${detail.flag}`])
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})